import React from "react";

import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const IframeContainer = styled.div`
    display: flex;  
    width: 100%;
    height: 100%;

    flex-direction: column;
    margin-top: 10px;
    
    p {
        font-size: 0.75rem;
    }
`;

interface IframeAnswerProps {
    link: string;
    height?: number;
}

//TODO button click doesnt work
const IframeAnswer: React.FC<IframeAnswerProps> = ({ link, height }) => {
    const { t } = useTranslation();
    
    return (
        <IframeContainer>
            <p style={{ marginTop: '0', textAlign:'left' }}>
                <span style={{ marginRight: '5px' }}><FontAwesomeIcon icon={faInfoCircle} /></span>
                {t('qna_iframe_disclaimer')}
            </p>
            <iframe src={link} allowFullScreen style={{ border: '0px', width: '100%', height: height ?? '400px', margin:'10px 0 20px 0' }}></iframe>
        </IframeContainer>
    )
}
export default IframeAnswer;